import { render, staticRenderFns } from "./TaskAdminListOrderTaskPop.vue?vue&type=template&id=790a4eb4&"
import script from "./TaskAdminListOrderTaskPop.vue?vue&type=script&lang=js&"
export * from "./TaskAdminListOrderTaskPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports